<template>
  <v-layout wrap :class="containerClass">
    <v-flex
      v-for="(message, i) in messages"
      :key="i"
      xs12
      class="planner-comm__message"
    >
      <div class="mobile-date">
        {{ displayDate(message._timestamp) }}
      </div>
      <message-container v-if="sender && receiver">
        <template v-slot:header>
          <v-layout style="margin-bottom: 15px" wrap align-center>
            <v-flex align-center xs10 class="message_name">
              <v-avatar v-if="getAvatar(message.from)" size="30px" style="margin-right: 15px">
                <img :src="getAvatar(message.from).link">
              </v-avatar>
              <v-avatar
                v-else
                size="30px"
                style="margin-right: 15px"
                :color="colors[getUserData(message.from, 'name')[0]]"
              >
                <span class="white--text">{{ getUserData(message.from, 'name') | initials }}</span>
              </v-avatar>
              <div class="message__sender-name text-left">
                {{ getUserData(message.from, 'name') }}
              </div>
            </v-flex>
            <v-flex
              xs2
              class="text-right message_date"
            >
              {{ displayDate(message._timestamp) }}
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:body>
          <v-flex
            xs12
            class="text-xs-left message__body"
          >
            <div v-if="message.metadata">
              <provide-feedback-message
                v-if="message.metadata.message_type === 'feedback_request'"
                :agent="receiver"
                :client="sender"
                :message="message"
                @provide-feedback-btn-clicked="emitProvideFeedback($event)"
              />
              <route-details-message
                v-else-if="message.metadata.message_type === 'route_schedule'"
                :message="message"
                :route="getMessageRoute(message.metadata.data.thread.route_id)"
              />
              <default-message v-else :message="message" />
            </div>
            <default-message v-else :message="message" />
          </v-flex>
        </template>
      </message-container>
    </v-flex>
    <div id="scroll-to" />
  </v-layout>
</template>

<script>
import moment from 'moment'
import avatarColors from '../../utils/avatarColors'
import MessageContainer from './MessageContainer'
import ProvideFeedbackMessage from './messages/ProvideFeedbackMessage'
import RouteDetailsMessage from './messages/RouteDetailsMessage'
import DefaultMessage from './messages/DefaultMessage'
import { sortObjectArrayByKey } from '../../utils/generalUtils'

export default {
  components: {
    ProvideFeedbackMessage,
    RouteDetailsMessage,
    DefaultMessage,
    MessageContainer
  },
  filters: {
    initials: function(value) {
      if (!value) return ''
      value = value.split(' ')
      let response = ''
      for (const v of value) {
        response = response + v.charAt(0).toUpperCase()
      }
      return response
    }
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    sender: {
      type: Object,
      default: () => ({})
    },
    receiver: {
      type: Object,
      default: () => ({})
    },
    containerClass: {
      type: String,
      default: () => ''
    },
    clientRoutes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      senderClasses: 'offset-xs2 message message__sender',
      receiverClasses: 'xs10 message message__receiver',
      colors: avatarColors,
      isReady: false,
      avatar: null
    }
  },
  watch: {
    messages() {
      this.showLatestMessage()
    }
  },
  mounted() {
    this.showLatestMessage()
  },
  methods: {
    getClass(message) {
      return message.from._id === this.sender._id ? this.senderClasses : this.receiverClasses
    },
    isSender(id) {
      return id === this.sender._id
    },
    displayDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },

    displayMessageOrigin(origin) {
      return origin === 'web' ? 'text' : origin
    },

    getAvatar(id) {
      return this.isSender(id) ? this.getAvatarMedia(this.sender) : this.getAvatarMedia(this.receiver)
    },

    getUserData(id, path) {
      return this.isSender(id) ? this.sender[path] : this.receiver[path]
    },

    getAvatarMedia(user) {
      return user && user.media
        ? user.media.find(item => item.type === 'avatar') : undefined
    },

    showLatestMessage() {
      setTimeout(() => {
        const options = {
          container: '.user-dialog_wrapper',
          force: true,
          y: true
        }
        const el = document.getElementById('scroll-to')
        this.$scrollTo(el, 1, options)
      }, 0)
    },

    emitProvideFeedback(message) {
      this.$emit('on-provide-feedback', message)
    },

    getMessageRoute(routeId) {
      let routeData = this.clientRoutes.find(route => route._id === routeId)
      if (routeData && routeData.routeStops && routeData.routeStops.length > 1) {
        let routeStops = [...routeData.routeStops]
        routeStops = sortObjectArrayByKey(routeStops, 'arrivalTime')
        routeData = { ...routeData, routeStops }
      }
      return routeData
    }
  }
}
</script>

<style lang="sass" scoped>
.message_name
  display: flex
  margin-bottom: 10px
.mobile-date
  display: none
  right: 1.5rem
  top: 2.5rem
.message
  margin-bottom: 10px
  &__subject
    margin-bottom: 10px
    color: $hwayzTeal

  &__body
    padding-left: 56px

  &__sender-name
    font-weight: bold

.planner-comm__message.message__sender
  background-color: $hwayzec

.planner-comm__message
  background-color: #fff
  border: 1px solid $hwayzec
  border-top: none
  font-size: 1.4rem
  padding: 1.5rem
  position: relative
  &:first-child
    border-top: 1px solid $hwayzec

.planner-comm__message .row
  cursor: pointer

.planner-comm__message .bold
  font-weight: 700

.planner-comm__message-subject
  font-size: 1.4rem
  padding-left: 3rem
  margin-bottom: 2rem

.planner-comm__message-detail
  padding: 2rem
  background-color: $hwayzfb
  border-radius: 0.5rem
  border: 2px solid $hwayzShadow
  font-size: 1.4rem
  margin-bottom: 4rem

.message__feedback-provide
  margin-top: 5px

.v-menu__content
  box-shadow: none
  border: 1px solid lightgray

/* Scrollbar style */
.planner-comm__message::-webkit-scrollbar-track
  background-color: $hwayzfb
  border-left: solid 2px white /* make the track seem narrower than the thumb */
  border-top: solid 5px $hwayzfb
.planner-comm__message::-webkit-scrollbar
  width: 14px
  background-color: $hwayzfb
.planner-comm__message::-webkit-scrollbar-thumb
  background-color: $hwayzfb
  border-left: solid 3px rgba($black, 0.4)

@media only screen and (min-width: 600px)
  .planner-comm__content
    padding: 3rem

@media only screen and (max-width: 768px)
  .message__sender
    .mobile-date
      bottom: 0
      left: -33px

  .message__receiver
    .mobile-date
      bottom: 0
      right: -33px

  .mobile-date
    display: block
    font-size: 10px
    font-style: italic
    position: absolute
    right: 1.5rem
  .message .message__subject
    flex-basis: 100%
    width: 100%
    margin-left: 0
    max-width: 100%

  .planner-comm__name
    display: none

  .message__body
    padding-left: 0

  .message_date
    display: none

  .message
    margin-left: -3px
    margin-right: -3px
</style>
